<ion-header>
  <ion-toolbar>
    <ion-title>Especialidades</ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar placeholder="Buscar" debounce="100" (ionInput)="search($event)" (ionCancel)="ionCancel()"
      (ionClear)="ionClear()"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <form [formGroup]="dataForm">
          <ion-list>
            <ion-item *ngFor="let item of arrayFiltered">
              <ion-checkbox label-placement="stacked" [disabled]="isDisabled == true && item?.selection !== 'single'"
                alignment="start" [checked]="isChecked(item)" [value]="item" (ionChange)="onCheckboxChange($event, item)">
                {{item.name}}
              </ion-checkbox>
            </ion-item>
          </ion-list>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button style="text-transform: uppercase;" (click)="clear()">
        Limpiar
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button style="text-transform: uppercase;" (click)="closeModal()">
        Cancelar
      </ion-button>
      <ion-button style="text-transform: uppercase;" (click)="select()" [disabled]="!!!dataForm?.valid">
        Ok
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>